import CryptoJS from 'crypto-js'

export const generateKey = () => {
    // Generate a random 256-bit key (32 bytes for AES-256)
    const secretKey = CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex)
}

const SECRET_KEY = 'c9ce87bd69d1a7155f912aabc9ed415f8abcd4d5b7a9bc6bfed22aebeb5cc6f6'

// Encrypt
export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
}

// Decrypt
export const decryptData = (cipherText) => {
    if (cipherText) {
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY)
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    } else return null
}
